// Task 1 (New-lead-table Tasks-only launch, 2026-07-03): single source of truth for
// the initial view-mode resolution, shared by NewLeadTable.jsx's Task-#46 wrapper
// gate (the one-shot initial `getNewLead` fetch) and NewLead.jsx's `newLeadViewMode`
// lazy state init + permissions-correction effect. Extracted so those two call
// sites literally cannot drift out of the same contract — independently hand-rolled
// conditionals are exactly the shape of bug the counter-perf sprint almost shipped
// (see newLeadCounterGate.js for the sibling pattern/rationale).
//
// Product decision (RCA .superpowers/sdd/rca-tasks-only.md, Q2/Q7): V2 (tasks-v2)
// practices are Tasks-only on this page — no URL param or localStorage value can
// switch a V2 practice back to Contact-attempts mode. Non-V2 practices are
// completely unaffected: they always resolve 'contacts'.
//
// Task 1 (mode-cleanup, 2026-07-04): the predicate no longer accepts/reads
// urlViewMode/storedViewMode. Since V2 always resolves 'tasks' and non-V2 always
// resolves 'contacts' regardless of those inputs, threading them through added no
// value and cost an eslint-disable. The ignore contract itself is still pinned by
// tests/unit/utils/resolveNewLeadViewMode.test.js.
/**
 * @param {boolean} isV2Enabled hasFeatureAccess('tasks-v2', practiceId)
 * @returns {'tasks'|'contacts'}
 */
export function resolveNewLeadViewMode(isV2Enabled) {
    return isV2Enabled ? 'tasks' : 'contacts';
}
